module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-left-item"
  }, [_vm._t("left-toolbar-before"), _vm._v(" "), (_vm.toolbars.bold) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-bold",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_bold) + " (ctrl+b)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('bold')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.italic) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-italic",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_italic) + " (ctrl+i)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('italic')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.header) ? _c('div', {
    staticClass: "op-icon fa fa-mavon-header dropdown dropdown-wrapper",
    class: {
      'selected': _vm.s_header_dropdown_open
    },
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_header) + " (ctrl+h)")
    },
    on: {
      "mouseleave": _vm.$mouseleave_header_dropdown,
      "mouseenter": _vm.$mouseenter_header_dropdown
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_header_dropdown_open),
      expression: "s_header_dropdown_open"
    }],
    staticClass: "op-header popup-dropdown",
    class: {
      'transition': _vm.transition
    },
    on: {
      "mouseenter": _vm.$mouseenter_header_dropdown,
      "mouseleave": _vm.$mouseleave_header_dropdown
    }
  }, [_c('div', {
    staticClass: "dropdown-item",
    attrs: {
      "title": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$click_header('header1')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.d_words.tl_header_one))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item",
    attrs: {
      "title": "## "
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$click_header('header2')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.d_words.tl_header_two))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item",
    attrs: {
      "title": "### "
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$click_header('header3')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.d_words.tl_header_three))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item",
    attrs: {
      "title": "#### "
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$click_header('header4')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.d_words.tl_header_four))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item",
    attrs: {
      "title": "##### "
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$click_header('header5')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.d_words.tl_header_five))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item",
    attrs: {
      "title": "###### "
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$click_header('header6')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.d_words.tl_header_six))])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.toolbars.header || _vm.toolbars.italic || _vm.toolbars.bold) ? _c('span', {
    staticClass: "op-icon-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.underline) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-underline",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "title": ((_vm.d_words.tl_underline) + " (ctrl+u)"),
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('underline')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.strikethrough) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-strikethrough",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "title": ((_vm.d_words.tl_strikethrough) + " (ctrl+shift+d)"),
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('strikethrough')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.mark) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-thumb-tack",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "title": ((_vm.d_words.tl_mark) + " (ctrl+m)"),
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('mark')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.superscript) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-superscript",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_superscript) + " (ctrl+alt+s)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('superscript')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.subscript) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-subscript",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_subscript) + " (ctrl+shift+s)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('subscript')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.alignleft) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-align-left",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_alignleft) + " (ctrl+l)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('alignleft')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.aligncenter) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-align-center",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_aligncenter) + " (ctrl+e)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('aligncenter')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.alignright) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-align-right",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_alignright) + " (ctrl+r)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('alignright')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.superscript || _vm.toolbars.subscript || _vm.toolbars.underline || _vm.toolbars.strikethrough || _vm.toolbars.mark) ? _c('span', {
    staticClass: "op-icon-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.quote) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-quote-left",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_quote) + " (ctrl+q)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('quote')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.ol) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-list-ol",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_ol) + " (ctrl+o)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('ol')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.ul) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-list-ul",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_ul) + " (ctrl+alt+u)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('ul')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.ul || _vm.toolbars.ol || _vm.toolbars.quote) ? _c('span', {
    staticClass: "op-icon-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.link) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-link",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_link) + " (ctrl+l)")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$toggle_imgLinkAdd('link')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.imagelink) ? _c('div', {
    staticClass: "op-icon fa fa-mavon-picture-o dropdown dropdown-wrapper",
    class: {
      'selected': _vm.s_img_dropdown_open
    },
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "mouseleave": _vm.$mouseleave_img_dropdown,
      "mouseenter": _vm.$mouseenter_img_dropdown
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_img_dropdown_open),
      expression: "s_img_dropdown_open"
    }],
    staticClass: "op-image popup-dropdown",
    class: {
      'transition': _vm.transition
    },
    on: {
      "mouseleave": _vm.$mouseleave_img_dropdown,
      "mouseenter": _vm.$mouseenter_img_dropdown
    }
  }, [_c('div', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$toggle_imgLinkAdd('imagelink')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.d_words.tl_image))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/gif,image/jpeg,image/jpg,image/png,image/svg",
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        return _vm.$imgAdd($event)
      }
    }
  }), _vm._v(_vm._s(_vm.d_words.tl_upload) + "\n                ")]), _vm._v(" "), _vm._l((_vm.img_file), function(item, index) {
    return (item && item[1]) ? _c('div', {
      key: index,
      staticClass: "dropdown-item dropdown-images",
      attrs: {
        "title": item[1].name
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgFileListClick(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item[1].name))]), _vm._v(" "), _c('button', {
      staticClass: "op-icon fa fa-mavon-times",
      attrs: {
        "slot": "right",
        "type": "button",
        "aria-hidden": "true",
        "title": _vm.d_words.tl_upload_remove
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgDel(index)
        }
      },
      slot: "right"
    }), _vm._v(" "), _c('img', {
      staticClass: "image-show",
      class: {
        'transition': _vm.transition
      },
      attrs: {
        "src": item[1].miniurl,
        "alt": "none"
      }
    })]) : _vm._e()
  })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.toolbars.code) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-code",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_code) + " (ctrl+alt+c)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('code')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.table) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-table",
    attrs: {
      "disabled": !_vm.editable,
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_table) + " (ctrl+alt+t)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('table')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.link || _vm.toolbars.imagelink || _vm.toolbars.code || _vm.toolbars.table) ? _c('span', {
    staticClass: "op-icon-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.undo) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-undo",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_undo) + " (ctrl+z)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('undo')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.redo) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-repeat",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_redo) + " (ctrl+y)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('redo')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.trash) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-trash-o",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_trash) + " (ctrl+breakspace)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('trash')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.save) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-floppy-o",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_save) + " (ctrl+s)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('save')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("left-toolbar-after"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.s_img_link_open) ? _c('div', {
    staticClass: "add-image-link-wrapper"
  }, [_c('div', {
    staticClass: "add-image-link"
  }, [_c('i', {
    staticClass: "fa fa-mavon-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.s_img_link_open = false
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.link_type == 'link' ? _vm.d_words.tl_popup_link_title : _vm.d_words.tl_popup_img_link_title))]), _vm._v(" "), _c('div', {
    staticClass: "link-text input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link_text),
      expression: "link_text"
    }],
    ref: "linkTextInput",
    attrs: {
      "type": "text",
      "placeholder": _vm.link_type == 'link' ? _vm.d_words.tl_popup_link_text : _vm.d_words.tl_popup_img_link_text
    },
    domProps: {
      "value": (_vm.link_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link_text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-addr input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link_addr),
      expression: "link_addr"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.link_type == 'link' ? _vm.d_words.tl_popup_link_addr : _vm.d_words.tl_popup_img_link_addr
    },
    domProps: {
      "value": (_vm.link_addr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link_addr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "op-btn cancel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.s_img_link_open = false
      }
    }
  }, [_vm._v(_vm._s(_vm.d_words.tl_popup_link_cancel))]), _vm._v(" "), _c('div', {
    staticClass: "op-btn sure",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$imgLinkAdd()
      }
    }
  }, [_vm._v(_vm._s(_vm.d_words.tl_popup_link_sure))])])]) : _vm._e()])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7500fd93", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7500fd93","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/md-toolbar-left.vue
// module id = 218
// module chunks = 0